// Settings (admin): the eleven settings tabs, in the same order as before.
// Only the open tab is mounted (General settings keeps its unsaved draft
// when its tab unmounts, and the other tabs keep their last saved values
// the same way).
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import Tabs from '@mui/material/Tabs';
import { tokens as c } from '../theme';
import { calmCaps } from '../components/modern';
import AppInformation from './AppInformation';
import GeneralSettings from './GeneralSettings';
import LanguageSetting from './LanguageSetting';
import SMTPSettings from './SMTPSettings';
import SmsSettings from './SmsSettings';
import CancellationReasons from './CancellationReasons';
import DriverIncentives from './DriverIncentives';
import LiveEventSettings from './LiveEventSettings';
import MileSettings from './MileSettings';
import OnboardingSettings from './OnboardingSettings';
import RingtoneSettings from './RingtoneSettings';

// Old capitalised labels ("GENERAL SETTINGS") read as sentences; a single
// word is left alone so acronyms (SMTP) stay as they are.
export default function Settings() {
  const [value, setValue] = useState(0);
  const { t, i18n } = useTranslation();

  const tabs = [
    { key: 'app', label: t('app_info'), component: <AppInformation /> },
    { key: 'general', label: t('general_settings'), component: <GeneralSettings /> },
    { key: 'language', label: t('language'), component: <LanguageSetting /> },
    { key: 'smtp', label: t('smtp', { defaultValue: 'SMTP' }), component: <SMTPSettings /> },
    { key: 'sms', label: t('smssettings'), component: <SmsSettings /> },
    { key: 'cancel', label: t('cancellation_reasons_title'), component: <CancellationReasons /> },
    { key: 'incentives', label: t('driver_incentives', { defaultValue: 'Driver Incentives' }), component: <DriverIncentives /> },
    { key: 'event', label: t('live_event', { defaultValue: 'Live Event' }), component: <LiveEventSettings /> },
    { key: 'miles', label: t('donkey_miles', { defaultValue: 'Donkey Miles' }), component: <MileSettings /> },
    { key: 'onboarding', label: t('onboarding_wizard', { defaultValue: 'Onboarding wizard' }), component: <OnboardingSettings /> },
    { key: 'ringtones', label: t('ringtones', { defaultValue: 'Ringtones' }), component: <RingtoneSettings /> },
  ];

  return (
    <Box dir={i18n.dir()} sx={{ width: '100%' }}>
      <Tabs
        value={value}
        onChange={(event, newValue) => setValue(newValue)}
        aria-label={t('settings_title')}
        variant="scrollable"
        allowScrollButtonsMobile
        sx={{ borderBottom: `1px solid ${c.OUTLINE}` }}
      >
        {tabs.map((tab, i) => (
          <Tab key={tab.key} label={/\s/.test(tab.label) ? calmCaps(tab.label) : tab.label} id={`simple-tab-${i}`} aria-controls={`simple-tabpanel-${i}`} />
        ))}
      </Tabs>
      <Box role="tabpanel" id={`simple-tabpanel-${value}`} aria-labelledby={`simple-tab-${value}`} sx={{ pt: 2.5 }}>
        {tabs[value].component}
      </Box>
    </Box>
  );
}
